export const SET_ACCOUNT_DATA = '@accounts/SET_ACCOUNT_DATA' as const;
export const SET_ACCOUNT_TRANSACTIONS = '@accounts/SET_ACCOUNT_TRANSACTIONS' as const;
export const SET_ACCOUNT_TRANSACTIONS_PAGE = '@accounts/SET_PAGE' as const;
